import { Card, CardContent, Grid, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  FaRocket,
  FaPlusCircle,
  FaListAlt,
  FaUsers,
  FaArrowRight,
} from "react-icons/fa";

const DashQuickActions = () => {
  const navigate = useNavigate();
  const actions = [
    {
      icon: <FaRocket />,
      title: "Launch Campaign",
      description: "Start a new RCS campaign",
      color: "#2e7d32",
      link: "/home/campaign",
    },
    {
      icon: <FaPlusCircle />,
      title: "Create Template",
      description: "Design new templates",
      color: "#1976d2",
      link: "/home/create-template",
    },
    {
      icon: <FaListAlt />,
      title: "Templates List",
      description: "Templated list view",
      color: "#ed6c02",
      link: "/home/templates",
    },
    {
      icon: <FaUsers />,
      title: "Contacts Group",
      description: "Manage your contacts list",
      color: "#9c27b0",
      link: "/home/configurations/contacts",
    },
  ];

  return (
    <Card
      sx={{
        mb: 3,
        background: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: 4,
        boxShadow: "0 1px 3px 0 rgba(31, 38, 135, 0.37)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ position: "relative", zIndex: 1, p: 3 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: "bold",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 1,
          }}
        >
          Quick Actions
        </Typography>
        <Grid container spacing={3}>
          {actions.map((action, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  p: 3,
                  boxShadow: "0 1px 3px 0 rgba(31, 38, 135, 0.37)",
                  textAlign: "left",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  background: "rgba(255, 255, 255, 0.05)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: 3,
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "3px",
                    background: `linear-gradient(90deg, ${action.color}, ${action.color}80)`,
                  },
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 12px 28px 0 rgba(31, 38, 135, 0.3)",
                    border: `1px solid ${action.color}40`,
                    background: `rgba(255, 255, 255, 0.1)`,
                    "& .action-icon": {
                      transform: "scale(1.1)",
                      color: action.color,
                    },
                    "& .arrow-icon": {
                      transform: "translateX(4px)",
                      opacity: 1,
                    },
                  },
                }}
                onClick={() => navigate(action.link)}
              >
                {/* Animated background effect */}
                <Box
                  sx={{
                    position: "absolute",
                    top: "-50%",
                    left: "-50%",
                    width: "200%",
                    height: "200%",
                    background: `linear-gradient(45deg, transparent, ${action.color}10, transparent)`,
                    transform: "rotate(45deg)",
                    transition: "all 0.3s ease",
                    opacity: 0,
                  }}
                  className="hover-effect"
                />

                <Box sx={{ position: "relative", zIndex: 1 }}>
                  {/* Icon with gradient background */}
                  <Box
                    className="action-icon"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 60,
                      height: 60,
                      borderRadius: 3,
                      background: `linear-gradient(135deg, ${action.color}30, ${action.color}10)`,
                      border: `1px solid ${action.color}20`,
                      color: action.color,
                      fontSize: "1.8rem",
                      mb: 2,
                      transition: "all 0.3s ease",
                    }}
                  >
                    {action.icon}
                  </Box>

                  {/* Content */}
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      mb: 1,
                      color: "text.primary",
                      fontSize: "1.1rem",
                    }}
                  >
                    {action.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mb: 2,
                      lineHeight: 1.5,
                      fontSize: "0.875rem",
                    }}
                  >
                    {action.description}
                  </Typography>

                  {/* Animated arrow */}
                  <Box
                    className="arrow-icon"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: action.color,
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      opacity: 0.7,
                      transition: "all 0.3s ease",
                    }}
                  >
                    Get started
                    <FaArrowRight size={12} style={{ marginLeft: "8px" }} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DashQuickActions;
